(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventswoop-tracking"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ventswoop-tracking]').forEach((form) => {
    if (form.dataset.trackingBound) return;
    form.dataset.trackingBound = 'true';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const number = form.elements.tracking_number.value.trim();
      if (!number) return;
      const button = form.querySelector('button');
      const status = form.querySelector('[data-tracking-status]');
      button.disabled = true;
      status.textContent = form.dataset.loading;
      try {
        if (!window.YQV5) {
          await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://www.17track.net/externalcall.js';
            script.onload = resolve;
            script.onerror = reject;
            document.head.append(script);
          });
        }
        window.YQV5.trackSingle({ YQ_ContainerId: form.dataset.resultsId, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: number });
        status.textContent = '';
      } catch (error) {
        status.textContent = form.dataset.error;
      } finally {
        button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
